"use client";

import AdDetailModel from "@/models/AdDetailModel";
import { Box, Theme, Typography } from "@mui/material";
import AdSummary from "./AdSummary";
import AdPedigreeTree from "./AdPedigreeTree";
import AdVideos from "./AdVideos";
import AdMeta from "./AdMeta";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { AdPendingAlert } from "./AdPendingAlert";

export const AD_DESCRIPTION_STYLING = (theme: Theme) => ({
  "& p": {
    margin: theme.spacing(0.25, 0),
    minHeight: "1.5em",
  },
  "& a": {
    textDecoration: "underline",
  },
  "& ul, & ol": {
    paddingLeft: theme.spacing(4),
    margin: theme.spacing(1, 0),
  },
});

export default function AdBody({ ad }: { ad: AdDetailModel }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 4,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          alignItems: "flex-start",
        }}
      >
        <AdPendingAlert ad={ad} />
        <Typography
          variant="h4"
          component="h1"
          sx={(theme) => ({
            fontWeight: "bold",
            [theme.breakpoints.down("md")]: {
              fontSize: "1.5rem",
            },
          })}
        >
          {ad.title}
        </Typography>
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${ad.location.label}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Typography
            sx={{
              textDecoration: "underline",
              display: "flex",
              gap: 0.5,
              alignItems: "center",
            }}
          >
            {ad.location.label}
            <OpenInNewIcon sx={{ height: "14px" }} />
          </Typography>
        </a>
        <AdMeta ad={ad} />
      </Box>
      {/* AJB: move other body components here too? */}
      <AdSummary ad={ad} />
      <Box>
        <Typography
          component="div"
          sx={AD_DESCRIPTION_STYLING}
          dangerouslySetInnerHTML={{
            __html: ad.descriptionHtml,
          }}
        />
      </Box>
      <Typography>{ad.priceGst}</Typography>
      <AdPedigreeTree ad={ad} />
      <AdVideos ad={ad} />
    </Box>
  );
}
